<template>
  <main-layout>
    <div class="container azSize">
      <br><br>
      <H1 class="pageTitle isPoppins">About</H1>

        <div class=" top15  accSettingsForm aboutText">

         <div class="has-text-right"> </div>
         <br><br>
          <p>We are like you, entrepreneurs looking to engage audiences with our digital offerings.  But competition is ferocious.  While online users have come to 
            expect ease of use and agility, the sheer size of the competitive landscape has tended to complicate what should really be simple. In short, as competition for attention has risen, consumers' 
            attention spans have decreased.</p>
<br>
          <p>This is why we created <b class="has-text-warning">Slink</b>, the “Quick Connection Platform.”  <b class="has-text-warning">Slink</b> is the result of decades of experience building solutions for different companies and institutions that required <b>connection</b> to their 
            audiences.  Our objective is to simplify this complex task.</p>
<br>
          <p>We have designed <b class="has-text-warning">Slink</b> to offer a simple and effective service, allowing any user to lease one or many keywords that can then be used as shortcuts to reach any web destination.  
            <b class="has-text-warning">Slink</b> allows you to choose words that are important to you and leverage them in your communications strategy to drive traffic efficiently.</p>
<br>
          <p>If you would like your ads on TV, radio, press, billboards or social media to carry a concrete and memorable call to action, you can now use the words you want 
            instead of a potentially confusing and complicated URL. <b class="has-text-warning">Slink</b> takes care of this, with full control remaining in your hands. We are reducing the dependency on a "clickable" URL in 
            favor of something that can be <b>remembered</b> and used quickly and efficiently to reach an online destination.</p>
<br>
        <!--   <p>All you need to do is visit slink.com and check if the words that interest you are available. Then you can register and reserve them, pointing your new domain, 
            “slink.com/yourword,” to any web URL you like. From that moment you will be able to avoid difficult to remember URLs and leverage words that your customers associate with what you offer.  
            This will work on any media where you promote your offerings. Customers will find you, easily.</p> 
<br>-->
          <p>Over many years, we built many sites and applications and were always looking for something as effective as this to propel our client’s success.  
            We never found a practical and secure way of doing it. So we decided to build it for ourselves, but also make it available for others to use.</p>
<br>
          <p>Now you can <b>own your words</b> and turn them into actions.
          </p>
          <br>
          <br>
          <br>
          <br>

        </div>
        <br> <br>
       
     
    </div>
  </main-layout>
</template>

<script>
import MainLayout from '../layouts/Main.vue'

export default {
  components: {
    MainLayout
  },

  mounted: function(){

    
    
    
     /* function groupByArray(xs, key){ 
       return xs.reduce(function (rv, x) { 
         let v = key instanceof Function ? key(x) : x[key]; 
         let el = rv.find((r) => r && r.key === v); 
         if (el) { 
           el.values.push(x); 
          } else { 
            rv.push({ key: v, values: [x] 
          }); 
        } return rv;
      }, 
    []); 
    } 

    let a = [{b: 27}, {b:27}, {b:28}]
    console.log(groupByArray(a, 'b')) */

   
  },

  methods: {
  
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/About.vue